<article
  class="rbc"
  [class.rbc--dragging]="dragging"
  [class.rbc--overdue]="dateTone === 'overdue'"
  [style.--rbc-accent]="stripeColor || null"
  tabindex="0"
  role="button"
  [attr.aria-label]="'Open ' + (ref || heading || 'record')"
  (click)="onOpen($event)"
  (keydown.enter)="onOpen($event)">
  <header class="rbc__top">
    <span class="rbc__ref">{{ ref || '—' }}</span>
    <span class="rbc__top-end">
      <span *ngIf="priorityLabel" class="rbc__priority" [style.color]="priorityColor || null">
        <span class="rbc__dot" [style.background]="priorityColor || null"></span>{{ priorityLabel }}
      </span>
      <button
        *ngIf="menu"
        type="button"
        class="rbc__menu"
        aria-label="More actions"
        aria-haspopup="true"
        (mousedown)="menuDown.emit($event)"
        (click)="menuClick.emit($event); $event.stopPropagation()">
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </span>
  </header>

  <p class="rbc__title" *ngIf="heading" [title]="heading">{{ heading }}</p>

  <div class="rbc__client" *ngIf="client">
    <span class="rbc__avatar">{{ client | initials }}</span>
    <span class="rbc__client-text">
      <span class="rbc__client-name" [title]="client">{{ client }}</span>
      <span class="rbc__sub" *ngIf="subtitle" [title]="subtitle">{{ subtitle }}</span>
    </span>
  </div>

  <footer class="rbc__meta">
    <span class="rbc__date" [class.rbc__date--overdue]="dateTone === 'overdue'" [class.rbc__date--today]="dateTone === 'today'">
      <i class="pi pi-calendar"></i>
      <span class="rbc__date-text" *ngIf="date; else noDate" [title]="dateLabel ? dateLabel + ' ' + (date | date: 'EEE d MMM y') : ''">
        <span *ngIf="dateLabel" class="rbc__date-label">{{ dateLabel }}</span>
        {{ date | date: 'd MMM y' }}
      </span>
      <ng-template #noDate><span class="rbc__date-text">{{ emptyDateText }}</span></ng-template>
      <span *ngIf="dateTone === 'overdue'" class="rbc__tag rbc__tag--danger">Overdue</span>
      <span *ngIf="dateTone === 'today'" class="rbc__tag rbc__tag--warning">Today</span>
      <span *ngIf="tag" class="rbc__tag">{{ tag }}</span>
    </span>
    <a *ngIf="phone" class="rbc__phone" [href]="'tel:' + phone" [title]="phone">
      <i class="pi pi-phone"></i>
    </a>
  </footer>
</article>
